import { IUserInfo, UserRoles, ITab, ITabKey, IContext } from "../../types";

const PersonIcon = (props) => (
	<svg
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		className="transition-colors duration-300"
		{...props}
	>
		<path
			d="M8 7a3 3 0 1 0 0-6 3 3 0 0 0 0 6m6 5a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v3h12z"
		/>
	</svg>
);


const GroupIcon = (props) => (
	<svg viewBox="0 0 1920 1920" xmlns="http://www.w3.org/2000/svg" {...props} className="transition-colors duration-300">
		<path
			d="M735.39 336.1c218.24 0 395.97 177.62 395.97 395.97v113.14c0 121.96-56.57 229.78-143.57 302.52 94.13 13.92 187.36 34.96 278.32 64.6 122.41 39.83 204.66 155.68 204.66 288.16v200.37l-26.81 16.63C1295.52 1809.8 1051.94 1920 735.39 1920c-174.8 0-439.76-35.19-708.69-202.51L0 1700.86v-189.4c0-140.62 89.26-263.04 221.97-304.78a1716 1716 0 0 1 260.33-59.51c-86.55-72.75-142.9-180.34-142.9-301.96V732.07c0-218.35 177.63-395.98 395.99-395.98M1183.4 0c218.23 0 395.97 177.62 395.97 395.98V509.1c0 121.96-56.57 229.9-143.57 302.53 94.13 13.91 187.24 35.07 278.32 64.6 122.41 40.05 204.66 155.79 204.66 288.27v200.36l-26.7 16.64c-77.61 48.3-181.81 101.03-308.18 140.74v-21.72c0-181.7-113.6-340.77-282.73-395.75a1720 1720 0 0 0-111.55-32.25 498 498 0 0 0 54.87-227.29V732.1c0-250.48-182.04-457.97-420.42-500.17C886.76 95.49 1023.66 0 1183.4 0"
			fillRule="evenodd"
		/>
	</svg>
);

const ShopIcon = (props) => (
	<svg
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
		className="transition-colors duration-300"
	>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M11 2a3 3 0 0 0-3 3v1q-.9-.01-1.59.07c-.59.07-1.15.24-1.64.66s-.73.96-.9 1.54q-.2.8-.34 1.96l-.01.06-.87 6.07c-.14 1-.26 1.86-.26 2.55 0 .73.13 1.45.65 2.06.52.6 1.22.83 1.94.93.68.1 1.55.1 2.56.1h8.92c1.01 0 1.88 0 2.56-.1.72-.1 1.42-.33 1.94-.93s.66-1.33.65-2.06c0-.69-.12-1.54-.26-2.55l-.88-6.13q-.14-1.15-.35-1.96a3 3 0 0 0-.89-1.54 3 3 0 0 0-1.64-.66Q16.9 5.99 16 6V5a3 3 0 0 0-3-3zm3 4V5a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v1zM9 8a1 1 0 0 1 1 1v2a1 1 0 1 1-2 0V9a1 1 0 0 1 1-1m7 1a1 1 0 1 0-2 0v2a1 1 0 1 0 2 0z"
		/>
	</svg>
);

const SupportIcon = (props) => (
	<svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg" {...props} className="transition-colors duration-300">
		<path
			d="M422.4 217.17c-6.6-67.82-46.72-174.5-170.66-174.5-123.95 0-164.07 106.67-170.67 174.5a59.5 59.5 0 0 0-38.4 55.9v29.87a59.74 59.74 0 0 0 119.47 0v-29.87a59.95 59.95 0 0 0-37.34-55.25c4.27-39.26 25.18-132.48 126.94-132.48s122.45 93.22 126.72 132.48a59.7 59.7 0 0 0-37.12 55.25v29.87a60 60 0 0 0 33.92 53.76c-8.96 16.85-31.79 39.68-87.9 46.5a42.67 42.67 0 1 0-35.62 66.14 42.7 42.7 0 0 0 37.97-23.68c91.52-10.46 120.75-57.6 129.92-85.34a59.5 59.5 0 0 0 41.17-57.38v-29.87a59.5 59.5 0 0 0-38.4-55.9m-302.93 85.78a17.07 17.07 0 0 1-34.13 0v-29.88a17.07 17.07 0 1 1 34.13 0zM384 273.08a17.07 17.07 0 1 1 34.14 0v29.87a17.07 17.07 0 0 1-34.14 0z"
			fillRule="evenodd"
		/>
	</svg>
);

export const tabs = [
	{
		key: "buyers",
		label: "کاربران",
		icon: <ShopIcon />,
	},
	{
		key: "vendors",
		label: "کاربران",
		icon: <ShopIcon />,
	},
	{
		key: "groups",
		label: "گروه ها",
		icon: <GroupIcon />,
	},

	{
		key: "support",
		label: "پشتیبانی",
		icon: <SupportIcon />,
	},
	{
		key: "members",
		label: "اعضا",
		icon: <PersonIcon />,
	},
];

export const adminChatTabs = ['members', 'groups']
export const affiliateChatTabs = ['members', 'groups']
export const buyersChatTabs = ['groups', 'vendors']
export const vendorsChatTabs = ['members', 'groups', 'buyers']

export function filterTabs(context: IContext, userInfo: IUserInfo): ITab[] {
	return (tabs as ITab[]).filter(t => {
		if (context === "support") {
			return t.key === "support"
		} else if (context === 'chat') {
			if (userInfo.role === UserRoles.ADMIN || userInfo.role === UserRoles.SUPER_ADMIN) {
				return adminChatTabs.includes(t.key)
			} else if (userInfo.role === UserRoles.AFFILIATE) {
				return affiliateChatTabs.includes(t.key)
			} else if (userInfo.role === UserRoles.BUYER || userInfo.role === UserRoles.GUEST) {
				return buyersChatTabs.includes(t.key)
			} else if (userInfo.role === UserRoles.VENDOR || userInfo.role === UserRoles.STAFF) {
				return vendorsChatTabs.includes(t.key)
			}
		}
		return false
	})
}